var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{class:['background-section', {'tile': _vm.tile}]},[_c('div',{staticClass:"title-light secondary-color"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"headline-heavy mt-1",staticStyle:{"width":"80%"}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }